window.Popper = require('popper.js').default;
window.$ = window.jQuery = require('jquery');
require('bootstrap');

$(function() {
  $(document).on('keypress', function(e) {
    console.log('keypress', e.which)
    if(e.which === 102) {
      if(document.fullscreen) {
        document.exitFullscreen().then(function() {})
        .catch(function(error) {
          console.error(error);
        });
      } else {
        document.getElementById('bar-container').requestFullscreen().then(function() {})
        .catch(function(error) {
          console.error(error);
        });
      }
    }
  });
  var players = {};
  var $slider = $('#slider');
  YT.ready(function() {
    $('.youtube-video-container').each(function(i) {
      var videoId = $(this).attr('data-video-id');
      $(this).attr('id', 'player-' + i);
      var player = new YT.Player($(this).attr('id'), {
        height: window.screen.height,
        width: window.screen.width,
        videoId: videoId,
        playerVars: {
          playsinline: 0,
          controls: 0,
          rel: 0,
          iv_load_policy: 3,
          modestbranding: 1,
          showinfo: 0
        },
        events: {
          onStateChange: function onPlayerStateChange(event) {
            if (event.data == YT.PlayerState.ENDED) {
              event.target.seekTo(0);
              event.target.pauseVideo();
              if($('[data-video-id="'+videoId+'"]').closest('.carousel-item').is('.active')) {
                $slider.carousel('next');
              }
            }
          }
        }
      });
      players[videoId] = player;
    });
  });
  $slider.on('slide.bs.carousel', function (event) {
    console.log(event.relatedTarget.id);
    var $slide = $(event.relatedTarget);
    if($slide.is('[data-type="youtube"]') && $slide.find('[data-video-id]').length) {
      var $player = $slide.find('[data-video-id]');
      var videoId = $player.attr('data-video-id');
      if(videoId in players) {
        var player = players[videoId];
        player.mute();
        player.playVideo();
      }
    }
  });
  $slider.on('slid.bs.carousel', function (event) {
    onSlideShown($(event.relatedTarget));
  });
  onSlideShown($slider.find('.carousel-item.active'));
  function onSlideShown($slide) {
    if($slide.is('[data-type="menu"]') || $slide.is('[data-type="picture"]')) {
      var duration = parseInt($slide.attr('data-duration'));
      setTimeout(function() {
        $slider.carousel('next');
      }, duration);
    }
  }
  $('*').scrollTop(0);
  function refreshMenu() {
    $.get(window.location.href + '?_t=' + (new Date).getTime(), function(r) {
      if(r && $(r).find('.menu-container').length) {
        $('.menu-container').html($(r).find('.menu-container').html());
      }
    });
  }
  setInterval(function() {
    refreshMenu();
  }, 15000);
});

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js').then(function(registration) {
    console.log('Service worker registration succeeded:', registration);
  }, function(error) {
    console.log('Service worker registration failed:', error);
  });
} else {
  console.log('Service workers are not supported.');
}